import { forwardRef } from 'react';
import { Toolbar as MuiToolbar, ToolbarProps as MuiToolbarProps } from '@mui/material';

export type ToolbarProps = MuiToolbarProps;

/**
 * Toolbar component - Horizontal flex container for AppBar contents.
 *
 * Thin wrapper around MUI Toolbar. Owns the standard AppBar inner row
 * (logo, nav, actions) and gives the design system a hook for global
 * spacing/height adjustments.
 */
export const Toolbar = forwardRef<HTMLDivElement, ToolbarProps>((props, ref) => (
  <MuiToolbar ref={ref} {...props} />
));

Toolbar.displayName = 'Toolbar';
